import { Dispatch } from 'redux';

import { SERVER_LOADED, CLIENT_LOADED } from '../constants/app';

export const serverLoaded = () => (dispatch: Dispatch) => dispatch({ type: SERVER_LOADED });

export const clientLoaded = () => (dispatch: Dispatch) => dispatch({ type: CLIENT_LOADED });
//
